import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { marked } from 'marked';

@Pipe({
  name: 'markdownHtml',
  standalone: true,
})
export class MarkdownHtmlPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(value: string | null | undefined): SafeHtml {
    const html = marked.parse(value ?? '', { gfm: true, breaks: true }) as string;
    // bypassSecurityTrustHtml: cp_question.statement is authored by internal admins only
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }
}
